import { useId, type InputHTMLAttributes, type ReactNode } from 'react';

interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  error?: string | null;
  hint?: string;
  /** אלמנט בקצה השדה (למשל כפתור הצגת סיסמה). */
  trailing?: ReactNode;
}

export function TextField({ label, error, hint, trailing, className = '', ...props }: TextFieldProps) {
  const id = useId();
  const describedBy = error ? `${id}-error` : hint ? `${id}-hint` : undefined;
  return (
    <div className={className}>
      <label htmlFor={id} className="mb-1.5 block text-[14px] font-medium text-ink-2">
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          className={[
            'block min-h-12 w-full rounded-control border bg-surface px-3.5 text-[16px] text-ink',
            'placeholder:text-ink-3 focus:border-brand focus:outline-none focus:ring-3 focus:ring-brand/20',
            error ? 'border-danger' : 'border-line-strong',
            trailing ? 'pe-12' : '',
          ].join(' ')}
          {...props}
        />
        {trailing && <div className="absolute inset-y-0 end-1 flex items-center">{trailing}</div>}
      </div>
      {error ? (
        <p id={`${id}-error`} className="mt-1.5 text-[13px] text-danger">
          {error}
        </p>
      ) : hint ? (
        <p id={`${id}-hint`} className="mt-1.5 text-[13px] text-ink-3">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
